/* @flow */
import * as React from 'react';

const YingYang = props => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    stroke="none"
    strokeWidth={1}
    fill="#FFF055"
    fillRule="evenodd"
    {...props}>
    <path d="M15,0 C6.729,0 0,6.729 0,15 C0,23.271 6.729,30 15,30 C23.271,30 30,23.271 30,15 C30,6.729 23.271,0 15,0 Z M2,15 C2,11.575 3.341,8.464 5.514,6.14 C5.633,7.35 5.882,8.417 6.285,9.383 C7.236,11.663 8.913,13.536 11.008,14.658 C12.077,15.231 13.204,15.6 14.294,15.957 C14.731,16.1 15.167,16.243 15.598,16.398 C19.323,17.745 21.947,21.115 22.709,25.444 C20.548,27.043 17.887,28 15,28 C7.832,28 2,22.168 2,15 Z M24.437,23.914 C23.3,19.439 20.339,15.986 16.277,14.517 C15.827,14.354 15.371,14.205 14.915,14.056 C13.861,13.711 12.866,13.385 11.952,12.895 C10.263,11.989 8.905,10.468 8.131,8.612 C7.779,7.769 7.572,6.858 7.48,5.747 C7.447,5.34 7.385,4.936 7.325,4.531 C9.479,2.948 12.128,2 15,2 C22.168,2 28,7.832 28,15 C28,18.451 26.639,21.584 24.437,23.914 Z" />
    <path d="M15,4 C13.346,4 12,5.346 12,7 C12,8.654 13.346,10 15,10 C16.654,10 18,8.654 18,7 C18,5.346 16.654,4 15,4 Z M15,9 C13.897,9 13,8.103 13,7 C13,5.897 13.897,5 15,5 C16.103,5 17,5.897 17,7 C17,8.103 16.103,9 15,9 Z" />
    <path d="M15,20 C13.346,20 12,21.346 12,23 C12,24.654 13.346,26 15,26 C16.654,26 18,24.654 18,23 C18,21.346 16.654,20 15,20 Z M15,25 C13.897,25 13,24.103 13,23 C13,21.897 13.897,21 15,21 C16.103,21 17,21.897 17,23 C17,24.103 16.103,25 15,25 Z" />
  </svg>
);

export default YingYang;



// WEBPACK FOOTER //
// ./src/assets/images/icons/ying-yang.js